<template>
  <div>
    <span @click="signout" style="cursor: pointer">
      <font-awesome-icon class="mx-4 light--text font-weight-bold mt-1" :icon="['fas', 'sign-out-alt']"></font-awesome-icon>
      <label class="text-body-1 light--text font-weight-bold" style="cursor: pointer">Logout</label>
    </span>
  </div>
</template>

<script>
import { onLogout } from "@/vue-apollo.js";
import { getCurrentUser } from "../methods/helper.js";
import { logoutAdminSession, clearLocalAuth } from "@/utils/session-manager.js";

export default {
  data() {
    return {
      user: null,
    };
  },

  created() {
    this.user = getCurrentUser.user;
  },
  methods: {
    async signout() {
      await logoutAdminSession("MANUAL");
      await onLogout(this.$apollo.provider.defaultClient);
      clearLocalAuth();
      this.$router.replace({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped></style>
